import type { OvpClient } from '@bldsoft/cappie/api/ovp'
import type { WebUserGetProfileExtraOutputDto } from '@bldsoft/ovp-api-types'
import type { API } from '@setplex/tria-api'
import { payload } from '../../result'
import { formatUsersPreferences } from './format'

export type { ApiUsersPreferences } from './index.h'

export function use(
  client: OvpClient,
  onboarding: API['onboarding'],
  _api: API
): void {
  // GET /api/web/onboarding/extra
  onboarding.getOnboardingExtraFx.use(async () => {
    const data = payload<WebUserGetProfileExtraOutputDto>(
      await client.get.api.web.onboarding.extra()
    )

    if (!data) {
      throw new Error('Empty answer in onboarding.getOnboardingExtraFx')
    }

    return formatUsersPreferences(data)
  })
}
